import { Tooltip, Icons } from '@/theme/index';

export function HistoryBasedValueTooltip({ icon }: { icon?: JSX.Element }) {
  return (
    <Tooltip
      data-testid="HBV-tooltip-icon"
      enterTouchDelay={300}
      title="History Based Value is an estimated valuation based on the history of a vehicle, including the known number of owners, accidents, mileage, and maintenance records."
    >
      {icon || <Icons.InfoOutlined sx={{ fontSize: '1.25rem', ml: 0.75 }} />}
    </Tooltip>
  );
}
